<template>
  <div id="specified-commercial-transactions-law">
    <call />
    <!-- header -->
    <header>
      <div class="l-header l-header-grey js-push-to-right push-to-right-grey">
        <div class="l-header__column l-header__column--left pl-16">
          <div class="l-header__btn-menu ssm-toggle-nav">
            <img src="/assets/images/icon/icon_menu_black.svg" class="l-header__btn-menu--open" />
            <img src="/assets/images/icon/icon-close.svg" class="l-header__btn-menu--close" />
          </div>
        </div>
        <div class="l-header__column l-header__column--mid">
          特定商取引法について
        </div>
        <div class="l-header__column l-header__column--right pr-61"></div>
      </div>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <section>
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--white pb-50">
          <div class="l-check-cart">
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                特定商取引法に基づく表記
              </div>
            </div>
            <div class="l-check-cart__body l-check-cart__body-padding mt-8">
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">販売業者</div>
                <div class="c-about-group__title mb-0">
                  イオンタウン株式会社
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">代表責任者</div>
                <div class="c-about-group__title mb-0">加藤　久誠</div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">所在地</div>
                <div class="c-about-group__title mb-0">
                  本社　〒261-8515　千葉県千葉市美浜区中瀬1丁目5番地1
                  イオンタワービル10階 <br />
                  <br />
                  幕　張　〒261-7118　千葉県千葉市美浜区中瀬2丁目6番地1 <br />
                  仙　台　〒980-0021　宮城県仙台市青葉区中央3丁目3番地3 <br />
                  名古屋　〒460-0003　愛知県名古屋市中区錦1丁目13番26号 <br />
                  大　阪　〒530-0001　大阪市北区梅田1丁目1番3−2900 <br />
                  福　岡　〒812-0016　福岡県福岡市博多区博多駅南2丁目9番地11
                  <br />
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Tenant } from "../plugin/mixin.js";
import Menu from "../components/Menu.vue";
import Vue from "vue";
import { Common } from "../common/common.js";
export default Vue.extend({
  name: 'CommercialLaw',
  components: {
    'menu-app': Menu
  },
  mixins: [Tenant],
  mounted() {
    Common.initDom();
  },
})
</script>